// /blockUsers 검색 필드 정의 (SearchToolbar config).
// 기존 인라인 <TextField> 1개를 이 배열 하나로 대체한다. field 키/operator는 기존과 동일.

import type { SearchFieldConfig } from "components/list";

export const blockUserSearchFields: SearchFieldConfig[] = [
  { name: "id", label: "ID에서 검색", type: "text", operator: "contains", width: 140 },
];
